import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

export const PageStyles = styled(OnboardingPage)`
  body.dark & {
    --loneliness-graph-image-content: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-dark.png);
  }

  --loneliness-graph-image-content: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-light.png);

  ion-content {
    .img-container {
      width: 100%;
      max-width: 280px;
      margin: 0 auto 24px;
      aspect-ratio: 0.795;

      @media screen and (min-width: 576px) {
        max-width: 430px;
        margin: 20px auto 0;
      }

      img {
        width: 100%;
        height: 100%;

        content: var(--loneliness-graph-image-content);
      }
    }
  }
`;

export const TitleStyles = styled(OnboardingTitle)`
  .ion-page & {
    margin: 24px auto 32px;
  }
`;

export const DescriptionStyles = styled.div`
  margin: 0 auto 0;
  text-align: center;
  padding: 0 16px;
`;
